import React from 'react';
import { Box } from '@mui/system';
import { Button, Chip, Grid, InputAdornment, Stack, TextField } from '@mui/material';
import CurrencyRupee from '@mui/icons-material/CurrencyRupee';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import { saveDynamicPrice } from 'services/operations/dynamicPricing';

const AmountDialog = ({onAmountUpdate, library}) => {
  const defaultFormFields={
    amount: 1000
  }
  const quickAmounts=[500, 1000, 2000, 5000, 10000];

  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, formState: { errors }, watch, setValue } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  const onAmountChipClick = (amount) => {
    setValue("amount", amount);
  }

  const onSubmit = (data) => {
    const postData = {
      amount: data.amount,
      propertyId: library?.libraryId,
      propertyType: "LIBRARY",
    };
    saveDynamicPrice({...postData}).then(({response, error}) => {
      if(response){
        onAmountUpdate(true);
      } else {
        onAmountUpdate(false);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });

  }
  return (
    <Box  
      component="form"
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid container rowSpacing={3} >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Controller
            control={control}
            name="amount"
            id="amount"
            rules={{ required: "Enter amount" }}
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Amount"
                type="number"
                required
                error={!!errors?.amount}
                size="small"
                fullWidth
                InputProps={{
                  startAdornment: <InputAdornment position="start"><CurrencyRupee sx={{fontSize: '1.2rem'}}/></InputAdornment>,
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display: 'flex'}} justifyContent="center">
          <Stack direction="row" spacing={2}>
            {quickAmounts.map((amount, index) => <Chip key={index} label={amount}  color={watch('amount') === amount ? "primary" : 'default'} onClick={() => onAmountChipClick(amount)} />)}
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display: 'flex'}} justifyContent="center">
          <Button variant="contained" type="submit">Proceed</Button>
        </Grid>
      </Grid>
    </Box>
  );
}
 
export default AmountDialog;
